module.exports = __webpack_public_path__ + "img/Hipercard.1cc249d3.svg";